import ReportsTable from "../../Components/Admin/Reports/ReportsTable";

function Reports() {

  return <ReportsTable />;
}

export default Reports;
